import {_warning, getBorderColor, message, resizeToBottomCorner, showLoading} from "./main";
import {initCopyToClipboard} from "./main_misc";
import {show} from "./main_modal";
import {defaultErrCallback, defaultJsonCallback} from "./main_callbacks";
import {getFunction} from "./main_system";
import {addRemoteTab, removeTab, showTab} from "./main_tabs";
import {msgResolve} from "./main_resolver";
import {reloadCurrent} from "./main_page";
import {submit} from "./main_form";
import {getLocale} from "./main_locale";
import {createCharts} from "./main_charts";


export const TINYMCE_CONFIG = {
	selector: '.tinymce',
	automatic_uploads: true,
	browser_spellcheck: true,
	extended_valid_elements: 'script[language|type|src],i[class]',
	plugins: [
		"advlist autolink lists link image charmap print preview anchor",
		"searchreplace visualblocks code fullscreen",
		"insertdatetime media table contextmenu paste image imagetools textcolor hr"
	],
	toolbar: "insertfile undo redo | styleselect | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image imagetools code | removeformat",
	content_css: "/dres/css/built.css",
	link_class_list: [
		{title: 'basic', value: ''},
		{title: 'button main', value: 'btn btn-main'},
		{title: 'button main & modal', value: 'btn ptx-show-modal btn-main'},
		{title: 'button new', value: 'btn btn-new'},
		{title: 'button new & modal', value: 'btn ptx-show-modal btn-new'},
		{title: 'button menu', value: 'btn btn-menu'},
		{title: 'button menu & modal', value: 'btn ptx-show-modal btn-menu'},
	],
	// Gets list of available public files of current reseller and offer them to user in dialog for insert image.
	image_list: '/dres/files.json'
};

/**
 * Create fully qualified url from given one
 * @alias Ptx.url
 * @url - may start with /positrex, or with #
 * @isLink - user for hrefs, append #
 */
export function getUrl(urlPath, isLink) {
	if (urlPath.startsWith('#')) {
		urlPath = urlPath.substring(1);
	}
	var completeUrl = urlPath;
	if (urlPath.startsWith(Ptx.baseUrl + '/')) {

	} else {
		completeUrl = Ptx.baseUrl + urlPath;
	}
	return completeUrl;
}

/**
 * Show modal after click event
 * @alias Ptx.fn.initShowModal
 * @param ctx
 */
export function initShowModal(ctx) {
	let $modal = $('a.ptx-show-modal', ctx);
	$modal.off('click');

	$modal.on('click', function (e) {
		e.preventDefault();
		var btn = $(this);
		var size = btn.data('ptx-modal-size');
		var cssClass = btn.data('ptx-modal-cssclass');
		var msg = btn.data('confirm-msg');
		var url = btn.attr('href');

		initModal(url, size, msg, cssClass);
	});
}


/**
 * Create modal and show
 * @alias Ptx.fn.initModal
 * @alias Ptx.fn.initModal
 * @param url
 * @param size
 * @param msg
 * @param cssClass
 */
export function initModal(url, size, msg, cssClass) {
	var modalSize = size ? size : 'modal-xl';
	if (msg) {
		if (!confirm(msg))
			return;
	}
	show('modal-form', getUrl(url), {
		ptxSize: modalSize,
		cssClass: cssClass,
		backdrop: 'static'
	});
}

/**
 * call url that make some action, and reload current page button - jQ object of
 * link
 * @alias Ptx.fn.callUrl
 */
export function callUrl(btn) {
	var urlPath = getUrl(btn.attr('href'));
	var callback = defaultJsonCallback;
	if (btn.data('callback')) {
		callback = getFunction(btn.data('callback'), window);
	}
	openWithParams(urlPath, "GET", {
		sm_dec: 'none'
	}, callback);
}

/**
 * jquery append element in 'ctx' parent with 'data'
 * @alias Ptx.fn.appendData
 * @param ctx
 *          selector
 * @param data
 *          to place
 */
export function appendData(ctx, data) {
	$(ctx).append(data);
}

/**
 * Remove DOM element as defined in data attribute of ele
 * @alias Ptx.fn.removeDom
 * @param ele -
 *          element with data-selector attribute with jQeury selector to remove
 */
export function removeDom(ele) {
	var sel = $(ele).data('selector');
	var item = $(sel);
	item.remove();
}

/**
 * s Init components for summary datatables only
 * @alias Ptx.fn.initSummaryComponents
 * @param ctx
 */
export function initSummaryComponents(ctx) {
	var $ctx = $(ctx);
	initShowModal($ctx);
	actionCall($ctx);
	initSendSmsLink($ctx);

    let scrollY = sessionStorage.getItem('contentScrollTop');

    if (!scrollY) {
        sessionStorage.setItem('contentScrollTop', '0');
    }

    window.addEventListener('scroll', function (_) {
        sessionStorage.setItem("contentScrollTop", this.scrollY.toString());
    })

	alignDropdown($ctx);
}

/**
 * init common components for modal, tabs and pages ,like datepicker or remote url
 * @param ctx where to init
 * @alias Ptx.fn.initComponents
 */
export function initComponents(ctx) {
	var $ctx = $(ctx);

	var dpSettings = {
		autoclose: true,
		language: getLocale('datepicker'),
		todayHighlight: true,
	};
	if (isRtl()) {
		Object.assign(dpSettings, {
			rtl: true
		});
	}

	// * P,M - init datepicker
	$('.date-picker-btn', $ctx).on('click', function () {
		// * P,M - init datepicker
		var $input = $(this).parent().find('.date-picker-input');
		$input.datepicker(dpSettings);
		$input.focus();
	});

	$('.date-picker', $ctx).each(function () {
		var settings = dpSettings;
		var dp = $(this);

        if (dp.hasClass('month-format')) {
            settings.format = Ptx.getMsg('format.dateMonth.js').toLowerCase();
            settings.minViewMode = 1;
        }

		if (dp.hasClass('day-format')) {
			settings.format = Ptx.getMsg('format.date.js').toLowerCase();
			settings.minViewMode = 0;
		}

        if (dp.hasClass('multiselect-date')) {
            settings.autoclose = false;
            settings.multidate = true;
            settings.multidateSeparator = ',';
        }

		dp.datepicker(settings);

		if (!dp.val() && dp.hasClass('default-today')) {
			dp.datepicker('update', new Date());
		}
	});

	charts(ctx);

	// Init colorpicker
	$('.color-picker', $ctx).each(function() {
		initColorPicker($(this));
	})

	Ptx.fn.initTooltips(ctx);
	initEnter(ctx);

	// * P,M - multiselect combobox
	var multiselectSettings = {
		enableHTML: true,
		numberDisplayed: 1,
		includeSelectAllOption: true,
		enableFiltering: true,
		includeFilterClearBtn: false,
		maxHeight: 600,
		allSelectedText: Ptx.getMsg('multiselect.allSelected'),
		selectAllText: Ptx.getMsg('common.choose.all'),
		nSelectedText: Ptx.getMsg('multiselect.nSelected'),
		nonSelectedText: Ptx.getMsg('multiselect.noneSelected'),
		filterPlaceholder: Ptx.getMsg('common.btn.search')
	};
	$('.ptx-simple-multiselect', $ctx).multiselect(multiselectSettings);
	$('.ptx-simple-multiselect-right', $ctx).multiselect(
		$.extend({}, multiselectSettings, {
			dropRight: true,
			buttonWidth: '150px',
		})
	);

	// * P,M - set height by window minus attribute
	$('[data-full-height]', $ctx).each(function () {
		fullHeight($(this), $(this).data('full-height'))
	});


	// TODO move to modal init
	// * M button to be opened in modal tab
	$('a.ptx-open-in-new-tab', $ctx).on('click', function (e) {
		e.preventDefault();
		var btn = $(this);
		var url = btn.attr('href');
		var tabId = btn.data('tab-id');
		var tabName = btn.data('tab-name');
		var modalTab = btn.hasClass('ptx-modal-tab');
		var autoClose = btn.hasClass('ptx-auto-close-tab');
		var css = false;
		if (modalTab) {
			css = 'ptx-modal-tab';
		}
		if (autoClose) {
			css = 'ptx-auto-close-tab';
		}
		ctx = Ptx.modal.ctx.window; // only in modal window there will be tab
		let tabLink = $('a[href="#' + tabId + '"]', ctx);
		if(tabLink.length > 0) {
			removeTab(tabId, ctx, -1);
		}
		addRemoteTab(tabId, {
			tabName: tabName,
			url: url,
			cssClass: css
		}, ctx);
		Ptx.modal.ctx.window.scrollTop(0);

		// leave confirm tab on leave, and close it on confirm
		var tab = $('a[href="#' + tabId + '"]', ctx)
		if (modalTab) {
			tab.on('hide.bs.tab', function (e) {
				e.preventDefault();
				Ptx.confirm(Ptx.getMsg('confirmCloseTab'), function (msg) {
					if (msg) {
						removeTab(tabId, ctx, -1);
						$(e.relatedTarget).tab('show');
					}
				});
			});
		}
		if (autoClose) {
			var tabz = Ptx.modal.ctx.tab;
			tab.on('hide.bs.tab', function (e) {
				if (tabz && tabz.onunload) {
					tabz.onunload(ctx);
				}
				removeTab(tabId, ctx, -1);
			});
		}
		Ptx.fn.initTab(ctx);
		showTab(tabId, ctx);
	});

	// * P,M - trigger that removes some DOM element (jQ selector in data-selector
	// attribute
	$('a.ptx-remove-dom', $ctx).on('click', function (e) {
		e.preventDefault();
		removeDom($(this));
	});

	reloadContentAll($ctx);
	initCheckGroup($ctx);
	initChosen($ctx);
	initSlideBtn(ctx);
	msgResolve($ctx);
	initShowAllChild($ctx);
	initShowChild($ctx);
	initSummaryComponents($ctx);
	alignDropdown($ctx);

	// add shift value into page filter and submit filter form
	$('.shift', $ctx).on('click', function (e) {
		e.preventDefault();
		var shift = $(this).data('ptx-shift');
		$('input[name="shift"]', ctx).val(shift);
		reloadCurrent();
	})

	// add shift value into page filter and submit filter form
	$('.shift-unit', $ctx).on('click', function (e) {
		e.preventDefault();
		var shift = $(this).data('ptx-shift');
		var index = $("#filterUnitId").prop('selectedIndex');
		$("#filterUnitId").prop('selectedIndex', index + shift);
		reloadCurrent();
	})

	// * P,M - simple ajax form submit that returns JsonDlgView with message
	$('.ptx-call-submit', $ctx).on('click', function (e) {
		e.preventDefault();
		var form = $(this).closest('form');
		submit(form, function (data, svr) {
			if (svr.isJson && data.submitFinal) {
				message(data.finalMsg);
			}
		});

	});

	$('.tags-input', $ctx).tagsinput(
			{itemValue: 'id', itemText: 'text', tagClass: 'label label-info font-big-i'}
	);
	$('.bootstrap-tagsinput').css('width', '100%');//not nice ! but they have weird css

	initCopyToClipboard();

	$('.ptx-address-suggest', $ctx).mapWhisperer();

	$('.icon-select', $ctx).selectpicker();
}

/**
 * align dropdown by window position
 * @alias Ptx.fn.alignDropdown
 * @param ctx
 */
export function alignDropdown(ctx) {
	$('.dropdown-menu', ctx).parent().on('show.bs.dropdown', function () {
		var t = $(this);
		var d = t.find(".dropdown-menu");
		var xDown = t.position().top + 100 + d.height();
		var wHeight = $(window).height() + $(window).scrollTop()

		if (xDown > wHeight) {
			d.css("margin-top", wHeight - xDown).css("margin-right", 30).addClass("alignByWindow");
		}
	})

	//remove added attribute 
	$('.dropdown-menu', ctx).parent().on('hide.bs.dropdown', function () {
		var t = $(this);
		var d = t.find(".dropdown-menu");
		if (d.hasClass("alignByWindow")) {
			d.removeClass("alignByWindow");
		}
	})
}

/**
 * create a new charts from prepare div data
 * @alias Ptx.fn.charts
 * @param ctx
 */
export function charts(ctx) {
	var $graphs = $('.ptx-render-graph:not(.done)', ctx);

	if ($graphs.length === 0) {
		return; // If no graph found, exit the function
	}

	var processGraph = function ($this) {
		var statType = $this.data('stat-type');
		var hash = $this.data('hash');
		var refreshChart = $this.data('refresh');
		var urlPath = "";

		if (statType) {
			urlPath = '/statistics/data/charts/' + statType + '.json';
		} else if (hash) {
			urlPath = '/public/statistics/data.json';
		} else {
			urlPath = $this.data('url');
		}

		var boxClass = null;
		if ($this.data('class')) {
			boxClass = $this.data('class');
		}
		var heightRatio = null;
		if ($this.data('heightratio')) {
			heightRatio = $this.data('heightratio');
		}
		var identify = "";
		if ($this.data('identify')) {
			identify = $this.data('identify');
		}
		var tooltipValue = "";
		if ($this.data('tooltipValue')) {
			tooltipValue = $this.data('tooltipValue');
		}
		var datax = {
			'unitId': $this.data('unit-id'),
			'client': $this.data('client-id'),
			'from': $this.data('from'),
			'to': $this.data('to'),
			'graphPeriodByData': $this.data('graph-period-by-data'),
			'limit': $this.data('limit'),
			'params': $this.data('params'),
			'trackId': $this.data('track-id'),
			'hash': $this.data('hash'),
			'providerParams': $this.data('provider-params')
		}

		/** @see GraphTag.java#getGraphPeriodByData() */
		if (!$this.data('graph-period-by-data')) {
			var dateFrom = $this.data('from');
			var dateTo = $this.data('to');
		}

		var loadData = function () {
			const showLoader = !datax.providerParams;
			if (showLoader) {
				showLoading(true, 'chart', null);
			}
			openWithParams(getUrl(urlPath), 'POST', datax, function (data) {
				var options = {
					data: {
						charts: data.charts
					},
					boxClass: boxClass,
					heightRatio: heightRatio,
					identify: identify,
					tooltipValue: tooltipValue,
					dateFrom: dateFrom,
					dateTo: dateTo
				};
				createCharts(options);

				if (data.charts.length === 1) {
					processNextGraph();
				} else if (refreshChart) {
					refresh(refreshChart, processNextGraph);
				}
				if (Ptx.onDataLoaded)
					Ptx.onDataLoaded()
			}, {
				locationName: "chart",
				showLoader: showLoader
			})
		}

		loadData();
		$this.addClass('done');
	};

	var currentIndex = 0;

	var processNextGraph = function () {
		if (currentIndex < $graphs.length) {
			processGraph($graphs.eq(currentIndex));
			currentIndex++;
		}
	};

	processNextGraph();
}

/**
 * This function initializes a color picker, transforming the regular select with hex codes into colorful squares.
 * @param select - the original select tag containing colors
 * @alias Ptx.fn.initColorPicker
 */
export function initColorPicker(select) {
	var colorpickerMenu = $('<div class="colorpicker-menu" id="customColorPicker"></div>');
	var colorpickerContainer = $('<div class="colorpicker-container"></div>');

	select.hide();
	// Populate color squares based on the original select options
	select.find('option').each(function () {
		var colorSquare = $('<div class="color-square"></div>');
		colorSquare.css('background-color', $(this).val());
		colorSquare.attr('data-color', $(this).val());
		colorpickerMenu.append(colorSquare);
	});

	// Set the selected color when clicking on a color square & trigger original select change
	colorpickerMenu.on('click', '.color-square', function () {
		var selectedColor = $(this).data('color');
		select.val(selectedColor);
		select.trigger('change');
		$(colorpickerContainer).css('background-color', select.val());
		colorpickerMenu.hide();
	});

	// Place the custom color picker to DOM
	select.after(colorpickerContainer);
	$(colorpickerContainer).css('background-color', select.val());
	select.after(colorpickerMenu);

	// Show/hide the custom color picker menu on click
	$(colorpickerContainer).click(function () {
		colorpickerMenu.toggle();
	});
}

/**
 * @alias Ptx.fn.initBatchActionCall
 * opts - object :
 * 	checkboxName - name of checkbox with ids, default 'unitId',
 *  idParamName - name of param to url, default 'unitId',
 *  selector - class to search for in link to activate this, defaults to 'ptx-batch-action'
 *  httpMethod - defaults to GET
 *  callback - function to be called when batch action is triggered
 *  afterCallback - function to be called after return from back-end, beware that replaces default defaultJsonCallback!!!
 */
export function initBatchActionCall(ctx, opts) {
	var opts = opts ? opts : {};
	var selector = opts.selector ? opts.selector : '.ptx-batch-action';
	var modalSize = opts.modalSize ? opts.modalSize : 'modal-full';
	if ($(selector, ctx).length === 0) {
		console.warn('initBatchActionCall ctx=', ctx, ', opts=', opts,
			' Will probably not work because selector found nothing at this time!');
	}
	$(selector, ctx).on('click', function (e) {
		e.preventDefault();

		var checkName = opts.checkboxName ? opts.checkboxName : 'unitId';
		var idParamName = opts.idParamName ? opts.idParamName : 'unitId';
		var httpMethod = opts.httpMethod ? opts.httpMethod : 'GET';

		var urlPath = $(this).attr('href');
		if (!urlPath || urlPath.trim() === '' || urlPath.trim() === '#') {
			urlPath = $(this).data('batch-href');
			// console.log('initBatchActionCall batch-href=', urlPath);
			if (!urlPath || urlPath.trim() === '') {
				console.error('href OR data-batch-href not found!');
				return;
			}
		}

		var checkBoxesSelector = "input[type='checkbox'][name='" + checkName + "']:checked";
		var unitId = $(checkBoxesSelector).map(function () {
			return $(this).val();
		}).get();

		if (unitId.length == 0) {
			_warning(Ptx.getMsg('common.warn.itemsNotSelected'));
			if (opts.afterCallback) {
				opts.afterCallback();
			}
		} else {
			var params = {};
			params[idParamName] = unitId;

			if (opts['callback']) {
				opts.callback(urlPath, idParamName, unitId);
				return;
			}

			if (urlPath.contains(".json")) {
				var callback = opts.afterCallback ? opts.afterCallback : defaultJsonCallback;
				confirmedAction($(this),
					function () {
							openPtx(urlPath, httpMethod, params, callback, {});
						},
					function () {
						if (opts.afterCallback) {
							opts.afterCallback();
						}
					}
				);
			} else {
				show('modal-form', getUrl(urlPath), {
					backdrop: 'static',
					params: params,
					ptxSize: modalSize,
					method: httpMethod
				});
			}
		}
	});
}

/**
 * action that can be confirmed if data-confirm-msg is present
 * @alias Ptx.fn.actionCall
 * @param ctx
 */
export function actionCall(ctx) {
	$('a.ptx-call-action', ctx).off('click.callAction').on('click.callAction', function (e) {
		e.preventDefault();
		confirmedAction($(this), callUrl);
	});
}

/**
 * Helper for link (button) with confirm-msg that shows confirmation and calls
 * callback if confirmed, or do nothing otherwise
 * @alias Ptx.fn.confirmedAction
 * @param link
 * @param callback callback in case when user choose OK.
 * @param cancelCallback sometimes callback when the user chooses cancel is also needed
 */
export function confirmedAction(link, callback, cancelCallback) {
	var msg = link.data('confirm-msg');
	if (msg) {
		Ptx.confirm(msg, function (ok) {
			if (ok) {
				callback(link);
			} else {
				if (cancelCallback) {
					cancelCallback();
				}
			}
		});
	} else {
		callback(link);
	}
}

/**
 * show all child in datatable
 * @alias Ptx.fn.initShowAllChild
 * @param ctx
 */
export function initShowAllChild(ctx) {
	$('.do-showAllChild', ctx).off('click.showAllChild').on('click.showAllChild', function (e) {
		e.preventDefault();
		var obj = $(this);

		showHideAllChild(obj);
	});
}

/**
 * show all child in datatable
 * @alias Ptx.fn.initShowChild
 * @param ctx
 */
export function initShowChild(ctx) {
	$('.do-showChild', ctx).off('click.showChild').on('click.showChild', function (e) {
		e.preventDefault();
		var obj = $(this);

		showHideChild(obj);
	});
}

/**
 * show or hide all child in datatable
 * @alias Ptx.fn.showHideAllChild
 * @param obj
 */
export function showHideAllChild(obj) {
	if ($(obj).data('show-child') == false) {
		showHideSubRowsBtn(obj);
		$('.ptx-table').find('.btn-more').has('i.fa-plus').each(function () {
			showHideChild(this);
		});
	} else {
		showUnfoldSubRowsBtn(obj);
		$('.ptx-table').find('.btn-more').has('i.fa-minus').each(function () {
			showHideChild(this);
		});
	}
}

/**
 * show or hide child in datatable
 * @alias Ptx.fn.showHideChild
 * @param obj
 */
export function showHideChild(obj) {
	var rowId = $(obj).parent().closest('tr').attr('id');
	
	var isDefaultHidden = $(obj).data('show-child-default-is-hidden');
	if (isDefaultHidden === undefined) { // if missing defaults to hiding rows...
		isDefaultHidden = true;
	}
	
	var sessionName = $(obj).data('show-child-session-name');
	if (sessionName === undefined) { // if missing default to 'child'
		sessionName = 'child';
	}

	if ($(obj).data('show-child') == false) {
		showHideSubRowsBtn(obj);
		$("tr[data-child-of='" + rowId + "']").removeClass('hidden');
		
		if (isDefaultHidden) {
			addSession(sessionName, rowId);
		} else {
			removeSession(sessionName, rowId);
		}
	} else {
		showUnfoldSubRowsBtn(obj);
		$("tr[data-child-of='" + rowId + "']").addClass('hidden');
		
		if (isDefaultHidden === false) {
			addSession(sessionName, rowId);
		} else {
			removeSession(sessionName, rowId);
		}
	}
}

/**
 * Init links for sending SMS to unit
 * @alias Ptx.fn.initSendSmsLink
 * @param ctx
 */
export function initSendSmsLink(ctx) {
	$('.ptx-send-sms', ctx).on('click', function (e) {
		e.preventDefault();
		var lnk = $(this);
		var unitId = lnk.data('unit-id');
		var template = lnk.data('sms-template');
		var isUnitGDSP = lnk.data('gdsp');
		var params = {
			unitId: unitId,
			smsTemplateType: template
		}
		Ptx.confirm(Ptx.getMsg('sendConfirm.' + isUnitGDSP + '.' + template), function (msg) {
			if (msg) {
				openWithParams(getUrl("/vehicle/SMS/send.json"), "POST", params, function (data, srv) {
					if (data.smsSent) {
						message(data.message);
					} else {
						_warning(data.message);
					}
				});
			}
		});
	});
}

/**
 * Shows the button to hide the sub-items in datatable and sets the value of object data under key 'show-child' to true.
 * @alias Ptx.fn.showHideSubRowsBtn
 * @param obj
 */
export function showHideSubRowsBtn(obj) {
	$(obj).children('i').removeClass('fa-plus').removeClass('text-success');
	$(obj).children('i').addClass('fa-minus').addClass('text-danger');
	$(obj).data('show-child', true);
}

/**
 * Shows the button to unfold the sub-items in datatable and sets the value of object data under key 'show-child' to false.
 * @alias Ptx.fn.showUnfoldSubRowsBtn
 * @param obj
 */
export function showUnfoldSubRowsBtn(obj) {
	$(obj).children('i').removeClass('fa-minus').removeClass('text-danger');
	$(obj).children('i').addClass('fa-plus').addClass('text-success');
	$(obj).data('show-child', false);
}

/**
 * return localStorage json of define name
 * @alias Ptx.fn.getSession
 * @param name
 */
export function getSession(name) {
	return JSON.parse(localStorage.getItem(name));
}

/**
 * add new data to define session name
 * @alias Ptx.fn.addSession
 * @param name
 * @param value
 */
export function addSession(name, value) {
	var session = [];
	var storage = getSession(name);
	if (storage != null) {
		session = storage;
	}
	// Pushes the value and update array in storage only if the value is not already present in the array.
	// If the value is already present, then no action is needed because the value is already present in the array.
	if (!session.includes(value)) {
		session.push(value);
		localStorage.setItem(name, JSON.stringify(session));
	}
}

/**
 * set new data to define session name
 * @alias Ptx.fn.setSession
 * @param name
 * @param value
 */
export function setSession(name, value) {
	localStorage.setItem(name, JSON.stringify(value));
}

/**
 * remove some data from define session name
 * @alias Ptx.fn.removeSession
 * @param name
 * @param value
 */
export function removeSession(name, value) {
	var session = [];
	var storage = getSession(name);
	if (storage != null) {
		session = storage;
		session.splice(session.indexOf(value), 1);
	}
	localStorage.setItem(name, JSON.stringify(session));
}

/**
 * add and set cookie
 * @alias Ptx.fn.setCookie
 * @param cname
 * @param cvalue
 * @param exdays
 */
export function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + "; " + expires;
}

/**
 * get name from cookie
 * @alias Ptx.fn.getCookie
 * @param cname
 */
export function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ')
			c = c.substring(1);
		if (c.indexOf(name) == 0)
			return c.substring(name.length, c.length);
	}
	return "";
}

/**
 * reload all content in whole context
 * @alias Ptx.fn.reloadContentAll
 * @param ctx
 * @param callback - callback function to be called after content is loaded
 */
export function reloadContentAll(ctx, callback) {
	// * P,M - to this element load remote url from data-href
	$('.ptx-remote-content', ctx).each(function () {
		reloadContent($(this), undefined, undefined, callback);
	});
	$('.ptx-remote-content-no-loader', ctx).each(function () {
		reloadContent($(this), false, false);
	});
}

/**
 * load content into element, that have data-href attribute with url /positrex/aa/data.htm url
 * @alias Ptx.fn.reloadContent
 * @param ele - element to load
 * @param clearElement - clear content of ele before set new? Default value is true (original behaviour).
 * @param useLoader - use loader animation while refreshing content of ele? Default value is true (original behaviour).
 * @param callback - callback function to be called after content is loaded
 */
export function reloadContent(ele, clearElement, useLoader, callback) {
	const url = ele.data('href');
	if (clearElement === undefined) {
		clearElement = true;
	}
	if (useLoader === undefined) {
		useLoader = true;
	}
	if (clearElement) {
		ele.html('');
	}

	openWithParams(url, "GET", {
		sm_dec: 'none'
	}, function (data, srv) {
		// if (srv.isHtml) {
		ele.html(data);
		initComponents(ele);
        if (typeof callback === "function") {
            callback();
        }
		// Custom event that remote content was loaded successfully.
		ele.trigger('remote-content-loaded');
		// }
	}, {
        showLoader: useLoader
	});
}

/**
 * init chosen select boxes by class
 * @alias Ptx.fn.initChosen
 * @param ctx
 */
export function initChosen(ctx) {
	var config;

	if (isDesktop()) {
		config = {
			'.chosen-select': {
				width: "100%",
				disable_search_threshold: 10
			},
			'.chosen-select-deselect': {
				width: "100%",
				allow_single_deselect: true
			},
			'.chosen-select-no-single': {
				width: "100%",
				disable_search_threshold: 10
			},
			'.chosen-select-no-results': {
				width: "100%",
				no_results_text: 'Oops, nothing found!'
			},
			'.chosen-select-width': {
				width: "100%"
			}
		}
	}

	for (var selector in config) {
		if (isRtl()) {
			$(selector).addClass('chosen-rtl');
		}

		$(selector).chosen(config[selector]);
	}

	$('.chosen-container', ctx).on('click', function () {
		var ww = $(window).width();
		var $this = $(this);
		var drop = $this.find('.chosen-drop');
		var width = drop.width();

		var margin = $this.position().left;
		var wm = width + margin;

		if (ww < wm) {
			var widthSelect = $this.width();
			var left = widthSelect - width - 2;
			drop.css('margin-left', left)
		}
	})

	$('.ptx-multi-select-all, .ptx-multi-select-none').on('click', function (e) {
		e.preventDefault();
	});
}

export function initSlideBtn(ctx) {
	var $sliderContainer = $(".btn-slide-container", ctx);

	var buttonCount = $sliderContainer.find("button").length;
	var SLIDER_WIDTH = 100 / buttonCount;

	$sliderContainer.find("button").each(function (index) {
		$(this).on("click", function () {
			slideBg(index);
			setActiveButton($(this));
		});
	});

	const $firstButton = $sliderContainer.find("button").first();
	setActiveButton($firstButton);

	function slideBg(n) {
		let bgOffset = SLIDER_WIDTH * n;
		$sliderContainer.css("--bg-offset", bgOffset + "%");
	}

	function setActiveButton($clickedButton) {
		$sliderContainer.find("button").removeClass("active");
		$clickedButton.addClass("active");
	}
}


/**
 * @alias Ptx.fn.initSavingCollapseById
 * @param id
 * @param key
 * @param callback
 */
export function initSavingCollapseById(id, key, callback) {
	const selector = "#" + id;

	$(selector).on('shown.bs.collapse', function () {
		addSession(id, key);
		if (typeof callback === 'function') {
			callback();
		}
	});

	$(selector).on('hidden.bs.collapse', function () {
		removeSession(id, key);
		if (typeof callback === 'function') {
			callback();
		}
	});

	const session = getSession(id);
	if (session != null && session.includes(key)) {
		$(selector).collapse('show');
	}
}

/**
 * init mobile menu functionality
 * @alias Ptx.fn.initMobileMenu
 */
export function initMobileMenu() {
	$('#ptx-mobile-menu a').on('click', function (e) {
		if ($(this).hasClass('ptx-no-reload')) {
			e.preventDefault();
		}
		$('#ptx-mobile-menu li').removeClass('open');

		$(this).parents('li').addClass('open');
	});
}

/**
 * open page with given http method, and specified params, not suitable for file
 * upload!! for this use Ptx.form.submit
 * @alias Ptx.fn.openWithParams
 * @param url
 * @param method (get, post)
 * @param params = what to send
 * @param callback(data, srv, requestParams) = after response returns
 * @param opts
 *          aditional parameters (contentType,processData for upload), loader -
 *          id of loader image, errCallback(xhr, textStatus, error, url) -
 *          custom error handler as of jQuery $.ajax
 */
export function openWithParams(url, method, params, callback, opts) {
	let loader = '#loader';
    let showLoader = true;
	let locationName = 'page';
	let errClb = defaultErrCallback;
	let forceReload = false;

	let csrfToken = $("meta[name='_csrf']").attr("content");
	let csrfHeader = $("meta[name='_csrf_header']").attr("content");

	if (opts) {
		if (typeof opts.loader != 'undefined')
			loader = opts.loader;
        if (typeof opts.showLoader != 'undefined')
            showLoader = opts.showLoader;
		if (typeof opts.errCallback != 'undefined')
			errClb = opts.errCallback;
		if (typeof opts.forceReload != 'undefined')
			forceReload = opts.forceReload;
		if (typeof opts.locationName != 'undefined')
			locationName = opts.locationName;
	}

	let ajaxOpts = {
		cache: false,
		type: method,
		url: url,
		data: params,
		beforeSend: function(xhr) {
			xhr.setRequestHeader(csrfHeader, csrfToken);
			if (showLoader) {
				showLoading(true, locationName, loader);
			}
		},
	};

	if (opts) {
		if (typeof opts.contentType != 'undefined')
			ajaxOpts['contentType'] = opts.contentType;
		if (typeof opts.processData != 'undefined')
			ajaxOpts['processData'] = opts.processData;
	}
	return $.ajax(ajaxOpts).done(function (data, status, xhr) {
		if (showLoader) {
			showLoading(false, locationName, loader);
		}

		if (callback) {
			callback(data, createServerInfo(status, xhr, url, forceReload, params));
		}
	}).fail(function (xhr, textStatus, error) {
		errClb(xhr, textStatus, error, url, loader, params);
	});
}

/**
 * @alias Ptx.fn.downloadFile
 * @param url endpoint that returns file for download
 * @param parameters
 */
export function downloadFile(url, parameters) {
	fetch(url, {
		headers: {
			[$('meta[name="_csrf_header"]').attr('content')]: $('meta[name="_csrf"]').attr('content')
		},
		method: 'POST',
		body: JSON.stringify({parameters}),
		credentials: 'include'
	})
	.then(res => {
		let contentDisposition = res.headers.get('content-disposition').split(';');
		let name = res.url.substring(res.url.lastIndexOf('/') + 1);
		for (let item of contentDisposition) {
			if (item.contains('fileName=')) {
				name = item.replace('fileName=', '').replaceAll('\"', '').trim();
				break;
			}
		}
		return ({fileName: name, blob: res.blob()});
	})
	.then(async ({fileName, blob}) => {
		let a = document.createElement('a');
		a.href = window.URL.createObjectURL(await blob);
		a.download = fileName;
		a.click();
		a.remove();
	})
	.catch(err => Ptx.fn.jsonMessageBoxCallback(err))
}

/**
 * Same as Ptx.fn.openWithParams, but prepends application context to url
 * (/positrex) so it can be used for internal positrex calls only
 * @alias Ptx.fn.openPtx
 * @url - with leading slash, eg. /admin/user.htm
 */
export function openPtx(urlPath, method, params, callback, opts) {
	openWithParams(getUrl(urlPath), method, params, callback, opts);
}

/**
 * init checkbox groups with master checkbox that can handle group check and
 * uncheck based on master value class="ptx-check-group-master"
 * data-ptx-group="group1" for master checkbox class="ptx-check-group"
 * data-ptx-group="group1,group2" for slaves checkboxes, slaves can have more
 * groups
 * @alias Ptx.fn.initCheckGroup
 * @param ctx
 */
export function initCheckGroup(ctx) {
	// * P,M - master checkbox for group checkbox (defined with data-ptx-group)
	const masterSel = 'input.ptx-check-group-master';
	// * P,M - slave checkboxes for group checkbox (defined with data-ptx-group)
	const slavesSel = 'input.ptx-check-group';

	var masterReference = document.querySelectorAll(".ptx-check-group-master");
	var slaveReference = []; // selection is made before check whole group by master

	function getMaster(group) {
		return document.querySelector(masterSel + '[data-ptx-group="' + group + '"]');
	}

	function getSlaves(group) {
		return $(slavesSel + '[data-ptx-group*="' + group + '"]');
	}

	// init master - when user click on master input
	$(masterSel, ctx).on('change', onMasterChange);

	// when user click on slave input
	$(slavesSel, ctx).on('change', onSlaveChange);

	// fill master checkboxes depend on slaves
	$(masterSel, ctx).each(function () {
		var master = $(this);

		if (! master.is(':checked')) {
			var group = master.data('ptx-group');
			var uncheckedSlaves = document.querySelectorAll(slavesSel + "[data-ptx-group*=\"" + group + "\"]:not(:checked)").length;
			master.prop('checked', uncheckedSlaves === 0);
		}
	});

	function onSlaveChange() {
		var groups = $(this).data("ptx-group").split(" ");
		for (var g = 0, gl = groups.length; g < gl; g++) {
			var master = getMaster(groups[g]);
			var count = document.querySelector(slavesSel + "[data-ptx-group*=\"" + groups[g] + "\"]:not(:checked)");
			master.checked = count === null;
		}
	}

	function onMasterChange() {
		var master = $(this);
		var mGroup = master.data('ptx-group');
		var isMasterChecked = master.is(':checked');
		var slaves = getSlaves(mGroup);
		var masterChecked = []; // masters to be filled after checkout

		slaves.prop("checked", isMasterChecked);

		/* lookup after slaves are checked */
		slaveReference = document.querySelectorAll(slavesSel + ":not(:checked)");

		slaves.each(function () {
			var $group = $(this).data("ptx-group").replace(mGroup, "").trim(); // next master group name
			/* check if dom reference have at least 1 element with same class = master is not possible to be checked */
			for (var sr = 0, srl = slaveReference.length; sr < srl; sr++) {
				if (slaveReference[sr].classList.contains($group) || slaveReference[srl - sr - 1].classList.contains($group)) {
					return masterChecked.push({group: $group, checked: false});
				}
			}
			masterChecked.push({group: $group, checked: true});
		});

		/* loop to check masters */
		for (var m = 0, ml = masterReference.length; m < ml; m++) {
			for (var n = 0, nl = masterChecked.length; n < nl; n++) {
				if (masterReference[m].dataset["ptxGroup"] === masterChecked[n].group) {
					masterReference[m].checked = masterChecked[n].checked;
				}
			}
		}
	}
}

/**
 * @alias Ptx.fn.interval
 * @param time
 * @param callback
 * @return interval variable
 */
export function interval(time, callback) {
	return setInterval(callback, time);
}

/**
 * @alias Ptx.fn.delay
 * @param time
 * @param callback
 * @return timeout variable
 */
export function delay(time, callback) {
	return setTimeout(callback, time);
}

/**
 * @alias Ptx.fn.clearDelay
 * @param time
 * @param callback
 * You ca used it only once on curent page! (bacouse Ptx.refresh variable)
 */
export function clearDelay(time, callback) {
	clearTimeout(Ptx.refresh);
	Ptx.refresh = delay(time, callback);
}

/**
 * @alias Ptx.fn.refresh
 * @param time
 * @param callback
 */
export function refresh(time, callback) {
	Ptx.page.ctx.refreshTime = time;
	clearRefresh();
	if (typeof callback === 'function') {
		Ptx.page.ctx.refresh = setInterval(function () {
			callback();
		}, time);
	} else {
		Ptx.page.ctx.refresh = setInterval(function () {
			reloadCurrent()
		}, time);
	}
}

/**
 * @alias Ptx.fn.clearRefresh
 */
export function clearRefresh() {
	if (typeof Ptx.page.ctx.refresh !== 'undefined') {
		clearInterval(Ptx.page.ctx.refresh);
	}
}

/**
 * @alias Ptx.fn.refreshArr
 * @param time
 * @param callback
 * @param key
 */
export function refreshArr(time, callback, key) {
	if (typeof Ptx.page.ctx.refreshTimeArr === "undefined") {
		Ptx.page.ctx.refreshTimeArr = [];
	}
	if (typeof Ptx.page.ctx.refreshArr === "undefined") {
		Ptx.page.ctx.refreshArr = [];
	}
	Ptx.page.ctx.refreshTimeArr[key] = time;
	clearRefreshArr(key);
	if (typeof callback === 'function') {
		Ptx.page.ctx.refreshArr[key] = setInterval(function () {
			callback();
		}, time);
	}
}

/**
 * @alias Ptx.fn.clearRefreshArr
 * @param key
 */
export function clearRefreshArr(key) {
	if (typeof Ptx.page.ctx.refreshArr[key] !== 'undefined') {
		clearInterval(Ptx.page.ctx.refreshArr[key]);
	}
}


/**
 * create server response object from status and xhr info in all callback is
 * available as srv object
 * @alias Ptx.fn.createServerInfo
 * @param textStatus
 * @param xhr - original XHR object from jquery
 * @param url
 * @param forceReload - if is requested to reload page after receiving response
 * @param requestParams - parameters for request sent
 * @returns server info object, see for details what is in there
 */
export function createServerInfo(textStatus, xhr, url, forceReload, requestParams) {
	if (typeof forceReload == 'undefined')
		forceReload = false;

	var ct = xhr.getResponseHeader("content-type") || "";
	var isJson = (ct.indexOf('json') > -1);
	var isHtml = (ct.indexOf('html') > -1);
	var result = {
		status: textStatus,
		xhr: xhr,
		ctype: ct,
		isJson: isJson,
		isHtml: isHtml,
		url: url,
		forceReload: forceReload,
		requestParams: requestParams

	};
	return result;
}

// MISC -----------------------------------
/**
 * color picker OLD, to DELETEs
 * @alias Ptx.fn.selectColor
 */
export function selectColor(color) {
	if (color != "") {
		$("[id^=\"color\"]").each(function (i) {
			this.style.border = "0";
		});
		$("#color" + color).css({
			"border": "2px dotted " + getBorderColor(color)
		});
		$("#color").val(color);
	}
	return false;
}

/**
 * color picker OLD, to DELETEs
 * @alias Ptx.fn.fullHeight
 */
export function fullHeight(obj, minus) {
	var winHeight = $(window).height();
	obj.height(winHeight - minus);
	return false;
}

/**
 * Check if it is mobile view
 * @alias Ptx.fn.isMobile
 */
export function isMobile() {
	return $(window).width() < 1260;
}

/**
 * Check if it is desktop view
 * @alias Ptx.fn.isDesktop
 */
export function isDesktop() {
	return $(window).width() >= 1260;
}

/**
 * Check if the device is in portrait mode
 * @alias Ptx.fn.isPortrait
 */
export function isPortrait() {
	return $(window).height() > $(window).width();
}

/**
 * Check if it is rtl view
 * @alias Ptx.fn.isRtl
 */
export function isRtl() {
	return Ptx.rtl === "true";
}

/**
 * callback only for desktop
 * @alias Ptx.fn.selectIfOnlyOne
 * @param element
 */
export function selectIfOnlyOne(element) {
	element.each(function () {
		var $that = $(this);
		var num = $that.find('option').length;
		if (num == 2) {
			var optVal = $that.find('option:last').val();
			if ($that.val() != optVal) {
				$that.val(optVal).change();
			}
		}
	});
}

/**
 * move element to start of element
 * @alias Ptx.fn.move
 * @param element
 * @param to
 */
export function move(element, to) {
	$(to).prepend($(element));
}

/**
 * move element to start of element
 * @alias Ptx.fn.moveEnd
 * @param element
 * @param to
 */
export function moveEnd(element, to) {
	$(to).append($(element));
}

/**
 * init submit by enter on form
 * @alias Ptx.fn.initEnter
 * @param ctx
 */
export function initEnter(ctx) {
	$('#ptx-filter-form', ctx).each(function () {
		var that = $(this);
		if (!that.hasClass("ptx-map-filter-form")) {
			that.find('input[type=text]:not(.chosen-search-input)', ctx).on('keydown', function (e) {
				if (e.which == 13) {
					that.submit();
				}
			});
		}
	});
}

/**
 * fixed filter
 * @alias Ptx.fn.fixedFilter
 * @param con
 *          condition true or false
 */
export function fixedFilter(con) {
	if (con) {
		$('#content').addClass('scroller-content');
		resizeToBottomCorner('.scroller-content', 'height');
	} else {
		$('#content').removeClass('scroller-content').removeAttr('style');
	}
}

/**
 * Diacritics list
 * @alias Ptx.diacriticsMap
 * Diacritics map for manipulating and removing diacritics from a string
 */

export const diacriticsMap = [
	{'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
	{'base':'AA','letters':/[\uA732]/g},
	{'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
	{'base':'AO','letters':/[\uA734]/g},
	{'base':'AU','letters':/[\uA736]/g},
	{'base':'AV','letters':/[\uA738\uA73A]/g},
	{'base':'AY','letters':/[\uA73C]/g},
	{'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
	{'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
	{'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
	{'base':'DZ','letters':/[\u01F1\u01C4]/g},
	{'base':'Dz','letters':/[\u01F2\u01C5]/g},
	{'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
	{'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
	{'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
	{'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
	{'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
	{'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
	{'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
	{'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
	{'base':'LJ','letters':/[\u01C7]/g},
	{'base':'Lj','letters':/[\u01C8]/g},
	{'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
	{'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
	{'base':'NJ','letters':/[\u01CA]/g},
	{'base':'Nj','letters':/[\u01CB]/g},
	{'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
	{'base':'OI','letters':/[\u01A2]/g},
	{'base':'OO','letters':/[\uA74E]/g},
	{'base':'OU','letters':/[\u0222]/g},
	{'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
	{'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
	{'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
	{'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
	{'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
	{'base':'TZ','letters':/[\uA728]/g},
	{'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
	{'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
	{'base':'VY','letters':/[\uA760]/g},
	{'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
	{'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
	{'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
	{'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
	{'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
	{'base':'aa','letters':/[\uA733]/g},
	{'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
	{'base':'ao','letters':/[\uA735]/g},
	{'base':'au','letters':/[\uA737]/g},
	{'base':'av','letters':/[\uA739\uA73B]/g},
	{'base':'ay','letters':/[\uA73D]/g},
	{'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
	{'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
	{'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
	{'base':'dz','letters':/[\u01F3\u01C6]/g},
	{'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
	{'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
	{'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
	{'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
	{'base':'hv','letters':/[\u0195]/g},
	{'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
	{'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
	{'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
	{'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
	{'base':'lj','letters':/[\u01C9]/g},
	{'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
	{'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
	{'base':'nj','letters':/[\u01CC]/g},
	{'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
	{'base':'oi','letters':/[\u01A3]/g},
	{'base':'ou','letters':/[\u0223]/g},
	{'base':'oo','letters':/[\uA74F]/g},
	{'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
	{'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
	{'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
	{'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
	{'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
	{'base':'tz','letters':/[\uA729]/g},
	{'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
	{'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
	{'base':'vy','letters':/[\uA761]/g},
	{'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
	{'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
	{'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
	{'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
];

/**
 * Diacritics removal
 * @alias Ptx.removeDiacritics
 * A function that loops over string letters and removes their accents, can be used for sorting without accents for example
 */

export function removeDiacritics ( s ) {
	for (var i=0, l=Ptx.diacriticsMap.length; i<l; i++) {
		s = s.replace(Ptx.diacriticsMap[i].letters, Ptx.diacriticsMap[i].base);
	}
	return s;
}

/**
 * Parse float number from given string
 * @alias Ptx.fn.parseFloat
 * @param {string} str
 * @return zero if empty string or undefined param given
 */
export function parseFloatNumber(str) {
	if (typeof str == 'undefined' || str === "") {
		return null;
	}
	return parseDecimalNumber(str, numeral.localeData(Ptx.lang).delimiters);
}

/**
 * @alias Ptx.fn.formatGps
 * @param obj
 * @return {string}
 */
export function formatGps(obj) {
	var lon = obj.lon;
	var lat = obj.lat;
	if (!lon || !lat) return '?';
	var latSymbol = '';
	if (lat > 0) latSymbol = 'N';
	else if (lat < 0) latSymbol = 'S';
	var lonSymbol = '';
	if (lon > 0) lonSymbol = 'E';
	else if (lon < 0) lonSymbol = 'W';
	return Math.abs(lat).toFixed(6) + latSymbol + ' ' + Math.abs(lon).toFixed(6) + lonSymbol;
}

/**
 * Set given data (Java SelectItems in JSON) to $tgt
 * @alias Ptx.fn.setSelectItems
 */
export function setSelectItems($tgt, data) {
	$tgt.empty();
	$.each(data, function (ind, data) {
		$('<option>').val(data.id).text(data.optionText).appendTo($tgt);
	});
}

/**
 * Handles selection of reseller and client mostly in modal dialogs.
 * Function must be combined with prepend include of JSP part "/WEB-INF/jsp/ptx3/createClientsArray.jsp" that creates clientsArray variable.
 * @param ctx context
 * @param clientsArray array that contains created options elements for all available clients of all available resellers.
 *                     This array can be created via "/WEB-INF/jsp/ptx3/createClientsArray.jsp".
 * @param elementsIds object that contains ids of key html elements for this function.
 * 					  <ul>
 * 					      <li>targetResellerId - name of the "select" element with list of available resellers.
 * 					      If not present then default value "targetResellerId" will be used.
 * 					      </li>
 * 					      <li>targetClientId - name of the "select" element with list of available clients of selected reseller.
 * 					      If not present then default value "targetClientId" will be used.
 * 					      </li>
 * 					  </ul>
 */
export function handleResellerClientSelect(ctx, clientsArray,
										   elementsIds={
											   targetResellerId: "targetResellerId",
											   targetClientId: "targetClientId"}) {
	$('#' + elementsIds.targetResellerId, ctx).on('change', function() {
		updateClientSelect($(this).val());
	});

	function updateClientSelect(selectedResellerId) {
		const clientSelect = document.getElementById(elementsIds.targetClientId);
		if (clientSelect) {
			clientSelect.options.length = 0;
			// var clientsArray comes from "/WEB-INF/jsp/ptx3/createClientsArray.jsp"
			if (selectedResellerId > 0) {
				for (var i = 0; i < clientsArray[selectedResellerId].length; i++) {
					clientSelect.options[clientSelect.options.length] = clientsArray[selectedResellerId][i];
				}
			}
		}
	}
}

export function handlePanels() {
	const menuBtn = $("#open-sidenav");
	const filterBtn = $("#open-filter");
	const closeFilterBtn = $("#ptx-filter-close");
	const mapBtn = $("#open-map");
	const panelMenu = $("#panel-menu");
	const panelFilter = $("#page-filter");
	const panelMap = $("#panel-maps");
	const panelOverlay = $("#panel-menu-overlay");

	function openNav() {
		if (panelMenu.children().length > 0) {
			panelMenu.addClass("active");
			panelOverlay.addClass("active");
		}
	}

	function openFilter() {
		panelFilter.addClass("active");
		panelOverlay.addClass("active");
	}

	function openMap() {
		panelMap.addClass("active");
	}

	function closeNav(event) {
		event.preventDefault();
		if (panelMenu && panelMenu.hasClass("active")) {
			panelMenu.removeClass("active");
		}
		if (panelFilter && panelFilter.hasClass("active")) {
			panelFilter.removeClass("active");
		}
		if (panelMap && panelMap.hasClass("active")) {
			panelMap.removeClass("active");
		}
		panelOverlay.removeClass("active");
	}

	if (menuBtn) menuBtn.on("click", openNav);
	if (filterBtn) filterBtn.on("click", openFilter);
	if (mapBtn) mapBtn.on("click", openMap);
	if (closeFilterBtn) closeFilterBtn.on("click", closeNav);
	if (panelOverlay) panelOverlay.on("click", closeNav);
}

/**
 * Gets translated message from session storage.<br>
 * <b>WARNING:</b> Don't use on publicly accessible pages, because messages isn't loaded into session storage on that pages!
 * @param key
 * @returns {string} value for key. If value for key cannot be obtained then key is returned.
 * Never returns null, undefined or empty string, so these values does not have to tested in code.
 */
export function getMsg(key) {
	const value = sessionStorage.getItem(key);
	// Un-comment it for debug of async behaviour of loading messages into session storage.
	// console.log(new Date().toISOString() + " | getMsg(" + key + ")=" + value);
	return value != null ? value : key;
}

/**
 * Stores translated message into session storage.
 * @param key
 * @param value
 */
export function setMsg(key, value) {
	sessionStorage.setItem(key, value);
}


/**
 * DEV NOTES:
 * ptx-download - is CSS class which serves only as marker class for file download
 */